import { LENGTH_REGEX, LOWERCASE_REGEX, NUMBER_REGEX, SPECIAL_CHARS_REGEX, UPPERCASE_REGEX } from "../services/validator.service";

export const PasswordRules = [
  { index: 1, label: "At least 8 characters", pattern: LENGTH_REGEX },
  { index: 2, label: "At least one number", pattern: NUMBER_REGEX },
  { index: 3, label: "At least one uppercase letter", pattern: UPPERCASE_REGEX },
  { index: 4, label: "At least one lowercase letter", pattern: LOWERCASE_REGEX },
  { index: 5, label: "At least a special Character (@:#$!%^()&+=;*_)", pattern: SPECIAL_CHARS_REGEX },
];